interface CreditCounterProps {
  creditsUsed: number;
  creditsTotal: number;
  onRequestMore: () => void;
}

const CreditCounter = ({
  creditsUsed,
  creditsTotal,
  onRequestMore,
}: CreditCounterProps) => {
  const remaining = creditsTotal - creditsUsed;
  const usagePercent = (creditsUsed / creditsTotal) * 100;

  const barColor =
    remaining <= 10
      ? "bg-sds-red-100"
      : remaining <= 40
        ? "bg-sds-yellow-100"
        : "bg-sds-green-100";

  const countColor =
    remaining <= 10
      ? "text-sds-red-100"
      : remaining <= 40
        ? "text-sds-yellow-100"
        : "text-[#494949]";

  return (
    <div className="flex items-center gap-2">
      <span className={`text-xs font-medium ${countColor}`}>
        {remaining} credits
      </span>
      <div className="w-12 h-1 bg-[#f0f0f0] rounded-full overflow-hidden">
        <div
          className={`h-full rounded-full transition-all ${barColor}`}
          style={{ width: `${usagePercent}%` }}
        />
      </div>
      <button
        type="button"
        className="text-[11px] text-[#a4a4a4] hover:text-[#494949] transition-colors"
        onClick={onRequestMore}
      >
        Request more
      </button>
    </div>
  );
};

export default CreditCounter;
